'use strict';

/**
 * @description Initialize event handlers on landing page
 */

window.addEventListener('mainJsLoaded', function () {
    monogrammingInit();
});

function monogrammingInit() {
    var $allCarousels = $('.js-section-carousel'),
        $carousel1 = $('.js-section-2-carousel'),
        $carousel2 = $('.js-section-3-carousel'),
        $carousel3 = $('.js-section-4-carousel'),
        $carousel4 = $('.js-section-5-carousel'),
        $carousel5 = $('.js-section-6-carousel'),
        $carousel1Tiles = $carousel1.find('.js-section-2-tile'),
        $carousel2Tiles = $carousel2.find('.js-section-3-tile'),
        $carousel3Tiles = $carousel3.find('.js-section-4-tile'),
        $carousel4Tiles = $carousel4.find('.js-section-5-tile'),
        $carousel5Tiles = $carousel5.find('.js-section-6-tile');

    // MLP - block 2: carousel 1
    if ($carousel1Tiles.length > 1) {
        $carousel1.slick({
            slidesToShow: 1,
            dots: true,
            arrows: false,
            infinite: false,
            swipe: true,
            autoplay: true,
        });
    }

    // MLP - block 4: carousel 3
    if ($carousel3Tiles.length > 1) {
        $carousel3.slick({
            slidesToShow: 1,
            dots: false,
            arrows: true,
            infinite: false,
            swipe: true,
            appendArrows: '#js-carousel3Arrows'
        });
    }

    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobileAndTablet'),
            enter: function () {
                // clean previous state
                $carousel5.slick('unslick');

                // MLP - block 3: carousel 2
                if ($carousel2Tiles.length > 1) {
                    $carousel2.slick({
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                        infinite: false,
                        swipe: true
                    });
                }

                // MLP - block 6: carousel 5
                if ($carousel5Tiles.length > 1) {
                    $carousel5.slick({
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                        infinite: false,
                        swipe: true
                    });
                }
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('fromDesktop'),
            enter: function () {
                // clean previous state
                $carousel2.slick('unslick');
                $carousel5.slick('unslick');

                // MLP - block 6: carousel 5
                if ($carousel5Tiles.length > 3) {
                    $carousel5.slick({
                        slidesToShow: 3,
                        dots: true,
                        arrows: false,
                        infinite: false,
                        swipe: true
                    });
                }
            }
        }
    ]);

    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobile'),
            enter: function () {
                // clean previous state
                $carousel4.slick('unslick');

                // MLP - block 5: carousel 4
                if ($carousel4Tiles.length > 1) {
                    $carousel4.slick({
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                        infinite: false,
                        swipe: true
                    });
                }
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('tablet'),
            enter: function () {
                // clean previous state
                $carousel4.slick('unslick');

                // MLP - block 5: carousel 4
                if ($carousel4Tiles.length > 3) {
                    $carousel4.slick({
                        slidesToShow: 3,
                        dots: false,
                        arrows: true,
                        infinite: true,
                        swipe: true
                    });
                }
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('desktop'),
            enter: function () {
                // clean previous state
                $carousel4.slick('unslick');

                // MLP - block 5: carousel 4
                if ($carousel4Tiles.length > 4) {
                    $carousel4.slick({
                        slidesToShow: 4,
                        dots: false,
                        arrows: true,
                        infinite: true,
                        swipe: true
                    });
                }
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('fromDesktopLarge'),
            enter: function () {
                // clean previous state
                $carousel4.slick('unslick');

                // MLP - block 5: carousel 4
                if ($carousel4Tiles.length > 5) {
                    $carousel4.slick({
                        slidesToShow: 5,
                        dots: false,
                        arrows: true,
                        infinite: true,
                        swipe: true
                    });
                }
            }
        }
    ]);

    // turn off lazyload postponed effect to avoid height issue
    $allCarousels.find('.lazyload').each(function (index, el) {
        window.lazySizes.loader.unveil(el);
    });
}
